import React from 'react';

import { IonContent, useIonPopover } from '@ionic/react';

import Button from 'components/Button';

import TypographyListContext from './TypographyListContext';

interface TypographyListConfig {
  limit?: number;
  unitsLabel?: string;
  variant?:
    | 'title'
    | 'subtitle1'
    | 'subtitle2'
    | 'body2'
    | 'caption'
    | 'overline'
    | 'medium';
  color?: string; // TODO: set colors
  lineClamp?: number;
}

export const TypographyList: React.FC<TypographyListConfig> = ({
  limit,
  children,
  variant,
  color,
  unitsLabel,
  lineClamp,
  ...props
}) => {
  const [present] = useIonPopover(() => (
    <IonContent class={'ion-padding'}>
      <TypographyListContext.Provider
        value={{
          variant,
          color,
          lineClamp,
        }}
      >
        {children}
      </TypographyListContext.Provider>
    </IonContent>
  ));

  const count = React.Children.count(children);

  if (limit === undefined || count <= limit) {
    return (
      <div {...props}>
        <TypographyListContext.Provider
          value={{
            variant,
            color,
            lineClamp,
          }}
        >
          {children}
        </TypographyListContext.Provider>
      </div>
    );
  }

  return (
    <div {...props}>
      <Button
        fill={'clear'}
        size={'small'}
        onClick={(e: any) =>
          present({
            event: e,
          })
        }
      >
        {count} {unitsLabel}
      </Button>
    </div>
  );
};
